import { IAction, KEEP_THE_SAME, StateStatus } from 'redux/utils/common';
import * as Types from './types';
import * as NewsService from 'services/api/news';
import * as ProductService from 'services/api/product';
import { LanguagesEnum } from 'constants/languages';

export interface IState {
  editNews: {
    status: StateStatus | null;
  };
  viewNews: {
    status: StateStatus | null;
    data: NewsService.IDataItems | null;
  };
  segments: {
    data: ProductService.ISegments | null;
    status: StateStatus | null;
  };
  temporaryTitle: Array<{ language: LanguagesEnum; value: string }>;
  temporaryShort: Array<{ language: LanguagesEnum; value: string }>;
  temporaryFull: Array<{ language: LanguagesEnum; value: string }>;
}

const initialState: IState = {
  editNews: {
    status: null,
  },
  viewNews: {
    status: null,
    data: null,
  },
  segments: {
    data: null,
    status: null,
  },
  temporaryTitle: [],
  temporaryShort: [],
  temporaryFull: [],
};

const NewEditReducer = (
  state: IState = initialState,
  action: IAction
): IState => {
  switch (action.type) {
    case Types.SET_EDIT_NEWS:
      return {
        ...state,
        editNews: {
          ...state.editNews,
          status: action.status || null,
        },
      };
    case Types.SET_NEWS_DETAIL:
      return {
        ...state,
        viewNews: {
          ...state.viewNews,
          status: action.status || null,
          data:
            action.data === KEEP_THE_SAME ? state.viewNews.data : action.data,
        },
      };
    case Types.SET_SEGMENTS:
      return {
        ...state,
        segments: {
          ...state.segments,
          status: action.status || null,
          data: action.data,
        },
      };
    case Types.UPDATE_TITLE_TEMPORARY:
      return {
        ...state,
        temporaryTitle: action.data,
      };
    case Types.UPDATE_SHORT_TEMPORARY:
      return {
        ...state,
        temporaryShort: action.data,
      };
    case Types.UPDATE_FULL_TEMPORARY:
      return {
        ...state,
        temporaryFull: action.data,
      };
    default:
      return {
        ...state,
      };
  }
};

export default NewEditReducer;
